<ng-container *ngIf="ready">
	<ng-container *ngIf="isV2(); else v1Checklist">
		<div class="checklist-v2" [class.checklist-v2--toc-collapsed]="tocCollapsed">
			<header class="checklist-v2-header">
				<div class="checklist-v2-titles">
					<span class="checklist-v2-location">{{ locationName$ | async }}</span>
					<h1 class="checklist-v2-title">{{ checklistTitle }}</h1>
				</div>

				<button
					type="button"
					class="checklist-v2-close"
					(click)="cancel()"
					[attr.aria-label]="'CHECKLIST_MODAL__CLOSE' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						close
					</span>
				</button>
			</header>

			<div class="checklist-v2-body">
				<div class="checklist-v2-main">
					<div class="checklist-v2-page-bar" *ngIf="pageMeta$ | async as pageMeta">
						<span class="checklist-v2-page-index">
							{{
								"CHECKLIST_MODAL__PAGE_OF"
									| transloco: { current: pageMeta.current, total: pageMeta.total }
							}}
						</span>
						<h2 class="checklist-v2-page-name">{{ activePage.name }}</h2>
					</div>

					<div class="checklist-v2-content">
						<app-checklist [page]="activePage" [form]="form"></app-checklist>
					</div>
				</div>

				@if (!tocCollapsed) {
					<aside class="checklist-v2-toc" [attr.aria-label]="'CHECKLIST_MODAL__PROGRESS' | transloco">
						<div class="checklist-v2-toc-sticky">
							@if (overallProgress$ | async; as overall) {
								<div class="checklist-v2-toc-summary">
									<div class="checklist-v2-toc-header">
										<button
											type="button"
											class="checklist-v2-toc-collapse"
											(click)="tocCollapsed = true"
											[attr.aria-label]="'CHECKLIST_MODAL__HIDE_PROGRESS' | transloco"
										>
											<span
												class="material-symbols-outlined material-symbols-outlined--size-24"
												aria-hidden="true"
											>
												arrow_menu_close
											</span>
										</button>
										<span class="checklist-v2-toc-heading">
											{{ "CHECKLIST_MODAL__PROGRESS" | transloco }}
										</span>
									</div>
									<div class="checklist-v2-toc-stats">
										<div class="checklist-v2-toc-fraction">
											<span class="checklist-v2-toc-completed">{{ overall.completed }}</span>
											<span class="checklist-v2-toc-of">
												/ {{ overall.total }} {{ "CHECKLIST_MODAL__ANSWERED" | transloco }}
											</span>
										</div>
										@if (overall.total > 0) {
											<span class="checklist-v2-toc-percent">{{ progressPercent(overall) }}%</span>
										}
									</div>
									<div class="checklist-v2-toc-bar" aria-hidden="true">
										<div
											class="checklist-v2-toc-bar-fill"
											[style.width.%]="progressPercent(overall)"
										></div>
									</div>
									<span class="checklist-v2-toc-remaining">
										{{
											"CHECKLIST_MODAL__QUESTIONS_REMAINING"
												| transloco: { remaining: overall.total - overall.completed }
										}}
									</span>
								</div>
							}

							@if (hasUnanswered$ | async) {
								<button
									type="button"
									class="checklist-v2-next-unanswered"
									(click)="goToNextUnanswered()"
								>
									<span>{{ "CHECKLIST_MODAL__NEXT_UNANSWERED" | transloco }}</span>
									<span
										class="material-symbols-outlined material-symbols-outlined--size-24"
										aria-hidden="true"
									>
										arrow_downward
									</span>
								</button>
							}
						</div>

						<nav class="checklist-v2-toc-list" [attr.aria-label]="'CHECKLIST_MODAL__PAGES' | transloco">
							@if (visiblePages$ | async; as pages) {
								<span class="checklist-v2-toc-pages-heading">
									<span>{{ "CHECKLIST_MODAL__PAGES" | transloco }}</span>
									<span class="checklist-v2-toc-pages-count">({{ pages.length }})</span>
								</span>
								<div class="checklist-v2-toc-list-scroll">
									@for (page of pages; track page.id; let i = $index) {
										@if (page.progress$ | async; as progress) {
											<button
												type="button"
												class="checklist-v2-toc-item"
												[class.checklist-v2-toc-item--active]="page.id === activePage.id"
												[class.checklist-v2-toc-item--complete]="
													progress.total > 0 && progress.completed === progress.total
												"
												[class.checklist-v2-toc-item--partial]="
													progress.completed > 0 && progress.completed < progress.total
												"
												(click)="goToPage(page.id)"
											>
												<span class="checklist-v2-toc-status" aria-hidden="true">
													@if (progress.total > 0 && progress.completed === progress.total) {
														<span class="material-symbols-outlined" aria-hidden="true">
															check_circle
														</span>
													} @else {
														{{ i + 1 }}
													}
												</span>
												<span class="checklist-v2-toc-label">{{ page.name }}</span>
												<span class="checklist-v2-toc-count">
													{{ progress.completed }}/{{ progress.total }}
												</span>
											</button>
										}
									}
								</div>
							}
						</nav>

						<p class="checklist-v2-toc-save-hint">
							<span class="material-symbols-outlined" aria-hidden="true">info</span>
							{{ "CHECKLIST_MODAL__SAVED_AS_YOU_GO" | transloco }}
						</p>
					</aside>
				} @else {
					<aside
						class="checklist-v2-toc checklist-v2-toc--collapsed"
						[attr.aria-label]="'CHECKLIST_MODAL__PROGRESS' | transloco"
					>
						<button
							type="button"
							class="checklist-v2-toc-expand"
							(click)="tocCollapsed = false"
							[attr.aria-label]="'CHECKLIST_MODAL__SHOW_PROGRESS' | transloco"
						>
							<span
								class="material-symbols-outlined material-symbols-outlined--size-24"
								aria-hidden="true"
							>
								arrow_menu_open
							</span>
							@if (overallProgress$ | async; as overall) {
								@if (overall.total > 0) {
									<span class="checklist-v2-toc-collapsed-percent">
										{{ progressPercent(overall) }}%
									</span>
								}
							}
						</button>
					</aside>
				}
			</div>

			<footer class="checklist-v2-footer">
				@if (overallProgress$ | async; as overall) {
					<span class="checklist-v2-footer-progress">
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							assignment
						</span>
						{{
							"CHECKLIST_MODAL__QUESTIONS_ANSWERED"
								| transloco: { completed: overall.completed, total: overall.total }
						}}
					</span>
				}

				<div class="checklist-v2-footer-actions">
					<button
						type="button"
						class="checklist-v2-nav-btn"
						(click)="previousPage()"
						[disabled]="isFirstPage"
					>
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							chevron_left
						</span>
						{{ "CHECKLIST_MODAL__PREVIOUS_PAGE" | transloco }}
					</button>
					<button type="button" class="checklist-v2-nav-btn" (click)="nextPage()" [disabled]="isLastPage">
						{{ "CHECKLIST_MODAL__NEXT_PAGE" | transloco }}
						<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
							chevron_right
						</span>
					</button>
					@if (form.valid) {
						<button type="button" class="checklist-v2-nav-btn checklist-v2-nav-btn--primary" (click)="submit()">
							{{ "CHECKLISTS__QUESTIONS__BUTTONS__SUBMIT" | transloco }}
						</button>
					}
				</div>
			</footer>
		</div>
	</ng-container>

	<ng-template #v1Checklist>
		<ion-header>
			<ion-toolbar>
				<ion-title color="primary">{{ activePage.name }}</ion-title>
				<ion-buttons slot="end">
					<ion-button color="primary" (click)="cancel()">
						<ion-icon slot="icon-only" name="close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-toolbar>

			<app-pagination
				[current]="activePage.id"
				[pages]="visiblePages$ | async"
				[isFirstPage]="isFirstPage"
				[isLastPage]="isLastPage"
				(goTo)="goToPage($event)"
				(next)="nextPage()"
				(previous)="previousPage()"
			></app-pagination>
		</ion-header>

		<ion-content>
			<app-checklist [page]="activePage" [form]="form"></app-checklist>
		</ion-content>

		<ion-footer>
			<ion-toolbar>
				<ion-buttons slot="start">
					<ion-button shape="round" fill="clear" (click)="previousPage()" [disabled]="isFirstPage">
						<ion-icon name="caret-back-outline"></ion-icon>
					</ion-button>
				</ion-buttons>

				<div class="finish-checklist-button-container">
					<ion-button [disabled]="form.invalid" fill="solid" shape="round" color="primary" (click)="submit()">
						{{ "CHECKLISTS__QUESTIONS__BUTTONS__SUBMIT" | transloco }}
					</ion-button>
				</div>

				<ion-buttons slot="end">
					<ion-button shape="round" fill="clear" (click)="nextPage()" [disabled]="isLastPage">
						<ion-icon name="caret-forward-outline"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-toolbar>
		</ion-footer>
	</ng-template>
</ng-container>
